export default class Cover {
  constructor(
    drivingRestrictionId,
    requestedVolExcess,
    requestedVolExcessId,
    previousInsurance,
    objectId,
    objectHistoryId
  ) {
    this.drivingRestrictionId = drivingRestrictionId;
    this.requestedVolExcess = requestedVolExcess;
    this.requestedVolExcessId = requestedVolExcessId;
    this.previousInsurance = previousInsurance;
    this.objectId = objectId;
    this.objectHistoryId = objectHistoryId;
  }
}
